import { render } from "./Tab6.vue?vue&type=template&id=0ea8af64&scoped=true"
import script from "./Tab6.vue?vue&type=script&lang=js"
export * from "./Tab6.vue?vue&type=script&lang=js"

import "./Tab6.vue?vue&type=style&index=0&id=0ea8af64&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea8af64"]])

export default __exports__